/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { StorageGateway } from '../models/StorageGateway';

export class ListStorageGatewaysResponse {
  'storageGateways'?: Array<StorageGateway>;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "storageGateways",
      "baseName": "StorageGateways",
      "type": "Array<StorageGateway>",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ListStorageGatewaysResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

